import { TestCasePresenter } from '@/presentation/presenters/testCase/testCasePresenter'
import { TestCaseViewModel } from '@/presentation/viewmodels/testCase/testCaseViewModel'

export function useTestCasePresenter(presenter: TestCasePresenter = new TestCasePresenter(new TestCaseViewModel())) {
  return {
    testCaseList: presenter.testCaseList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    getTestCaseList: presenter.getTestCaseList.bind(presenter)
  }
}
